module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter2"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#ch2"
    }
  }, [_vm._v("Basic Cake Pops")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cake pops are based on the same idea as cake balls, with the addition of a lollipop stick and a different approach to dipping. The lollipop sticks increase the cuteness factor, making them perfect for party favors and gifts.")]), _vm._v(" "), _c('h4', [_vm._v("Makes 48 cake pops")]), _vm._v(" "), _c('h4', [_vm._v("You’ll need")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("18.25-ounce box cake mix")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("9-by-13-inch cake pan")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Large mixing bowl")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("16-ounce container ready-made frosting")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Large metal spoon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Wax paper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 baking sheets")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Plastic wrap")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("48 ounces (3 pounds) candy coating")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Deep, microwave-safe plastic bowl")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("48 paper lollipop sticks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Styrofoam block (see "), _c('a', {
    attrs: {
      "href": "#/020chapter13"
    }
  }, [_vm._v("Equipment")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bake the cake as directed on the box, using a 9-by-13-inch cake pan. Let cool completely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once the cake is cooled, get organized and set aside plenty of time (a couple of hours) to crumble, roll, and dip 4 dozen cake pops.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Crumble the cooled cake into a large mixing bowl. See "), _c('a', {
    attrs: {
      "href": "#/014chapter7"
    }
  }, [_vm._v("“Crumbling Your Cake.”")]), _vm._v(" You should not see any large pieces of cake.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add three-quarters of the container of frosting. (You will not need the remaining frosting.) Mix it into the crumbled cake, using the back of a large metal spoon, until thoroughly combined. If you use the entire container, the cake balls will be too moist.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The mixture should be moist enough to roll into 1 "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v("-inch balls and still hold a round shape. After rolling the cake balls by hand, place them on wax paper–covered baking sheets.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cover with plastic wrap and chill for several hours in the refrigerator, or place in the freezer for about 15 minutes. You want the balls to be firm but not frozen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the candy coating in a deep, microwave-safe plastic bowl. These bowls make it easier to cover the cake balls completely with candy coating while holding the bowl without burning your fingers. (I usually work with about 16 ounces of coating at a time.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Melt the candy coating, following the instructions on the package. Microwave on medium power for 30 seconds at a time, stirring with a spoon in between. You can also use a double boiler. Either way, make sure you do not overheat the coating. See "), _c('a', {
    attrs: {
      "href": "#/016chapter9"
    }
  }, [_vm._v("“Candy Coating Basics,”")]), _vm._v(" for more on working with candy coating.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now you’re ready to dip. Take a few cake balls at a time out of the refrigerator or freezer to work with. If they’re in the freezer, transfer the rest of the balls to the refrigerator at this point, so they stay firm but do not freeze.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One at a time, dip about "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" inch of the tip of a lollipop stick into the melted candy coating, and then insert the lollipop stick straight into a cake ball, pushing it no more than halfway through.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("Holding the lollipop stick with cake ball attached, dip the entire cake ball into the melted candy coating until it is completely covered, and remove it in one motion. Make sure the coating meets at the base of the lollipop stick. This helps secure the cake ball to the stick when the coating sets. The object is to completely cover the cake ball and remove it without submerging it in the coating more than once. A small, deep plastic bowl is very helpful during this step. If you do resubmerge the cake pop, the weight of the candy coating can pull on the cake ball and cause it to get stuck in the coating.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The thinner the consistency of your coating, the easier it will be to coat the cake pops. If you find that your coating is too thick, add some shortening or paramount crystals (see "), _c('a', {
    attrs: {
      "href": "#/019chapter12#ParamountCrystals"
    }
  }, [_vm._v("Main Ingredients")]), _vm._v(") to help thin it and make the coating more fluid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When you remove the cake pop from the candy coating, some excess coating may start to drip. Hold the cake pop in one hand and use the other hand to gently tap the first wrist. Rotate the lollipop stick if necessary to allow the excess coating to fall off evenly, so one side doesn’t get heavier than the other. If you didn’t completely dunk the cake pop, this method of tapping and rotating generally takes care of that. The coating will slowly slide down the surface of the cake ball until it reaches the lollipop stick.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If too much coating surrounds the base of the lollipop stick, you can wipe the excess off with your finger. Simply place your finger on the stick right under the cake ball and spin the lollipop stick, allowing any excess coating to fall off and back into the bowl of coating. When most of the excess coating has fallen off and it is no longer dripping, stick the cake pop into the prepared Styrofoam block (see Tips).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Repeat with the remaining cake balls and let dry completely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Store the cake pops in an airtight container on the counter or in the refrigerator for several days. You can also cover them in small treat bags, tied with a ribbon, and leave them in the Styrofoam block on the counter.")]), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_vm._v("Tips")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Make the cake the day before and let it cool overnight.")]), _vm._v(" "), _c('li', [_vm._v("Use a toothpick to encourage the coating to cover any small exposed areas or to make sure it surrounds the lollipop stick.")]), _vm._v(" "), _c('li', [_vm._v("Make sure the cake balls are chilled and firm when you dip them. If they are room temperature, they are likely to fall off the lollipop sticks into the melted candy coating. You can always place them back in the freezer for a few minutes to quickly firm them up again.")]), _vm._v(" "), _c('li', [_vm._v("Poke holes in the Styrofoam block before you start dipping the pops. Just use one of the lollipop sticks to make holes about 2 inches apart.")]), _vm._v(" "), _c('li', [_vm._v("For fun, experiment with different colors of candy coating.")]), _vm._v(" "), _c('li', [_vm._v("Cake pops need more attention and therefore a little more time to complete than the cake balls. Set aside a couple of hours.")]), _vm._v(" "), _c('li', [_vm._v("When using the cake pop method, you can also make the balls in different shapes. Just roll them into balls, place in the freezer or refrigerator to firm, and then mold into your desired shape.")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image6"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    attrs: {
      "alt": "image 6",
      "src": "images/image-006-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-006-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-006-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-006-4.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a56d95e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008-chapter2.vue
// module id = 78
// module chunks = 0